import React from 'react';
import IntroBlock from './components/Intro/Intro';
import BrandsPartnerships from './components/Brands/Brands';
import UserSection from './components/UserSection/UserSection';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import BrandsRuningStroke from './components/BrandsRuningStroke/BrandsRuningStroke';

const PartnershipsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('partnership-title')}</title>
        <meta name="description" content={t('partnership-description')} />
      </Helmet>
      <div className="container">
        <IntroBlock />
      </div>
      <div style={{ background: '#ffffff' }}>
        <BrandsRuningStroke />
      </div>
      <div>
        <BrandsPartnerships />
      </div>
      <div className="container">
        <UserSection />
      </div>
    </>
  );
};

export default PartnershipsPage;
